// packages/web/src/pages/teach/LearningManagementPage.tsx
import React, { useEffect, useState } from 'react';
import { useTeacherLearningStore } from '../../stores/teacherLearningStore';
import { ExerciseUploadSection } from '../../components/teach/ExerciseUploadSection';
import { MaterialUploadSection } from '../../components/teach/MaterialUploadSection';
import { AIProgressSection } from '../../components/teach/AIProgressSection';
import { ExerciseCardsSection } from '../../components/teach/ExerciseCardsSection';
import { KnowledgePointsModal } from '../../components/teach/KnowledgePointsModal';
import { AssignModal } from '../../components/teach/AssignModal';
import { ExerciseLibraryTab } from '../../components/teach/ExerciseLibraryTab';
import { useStore } from '../../stores';

export const LearningManagementPage: React.FC = () => {
  const {
    showKnowledgePointsModal,
    showAssignModal,
    reset,
  } = useTeacherLearningStore();

  const { user } = useStore();
  const isParent = user?.role === 'parent';
  const [activeTab, setActiveTab] = useState<'create' | 'library'>('create');

  useEffect(() => {
    // 组件卸载时重置状态
    return () => reset();
  }, [reset]);

  return (
    <div className="teacher-learning-management min-h-screen bg-gray-50 p-6">
      {/* 标签页切换 */}
      <div className="mb-6">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex space-x-8">
            <button
              onClick={() => setActiveTab('create')}
              className={`
                py-4 px-1 border-b-2 font-medium text-sm transition-colors
                ${activeTab === 'create'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }
              `}
            >
              习题识别与创建
            </button>
            <button
              onClick={() => setActiveTab('library')}
              className={`
                py-4 px-1 border-b-2 font-medium text-sm transition-colors
                ${activeTab === 'library'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }
              `}
            >
              习题库
            </button>
          </nav>
        </div>
      </div>

      {/* 标签页内容 */}
      {activeTab === 'create' ? (
        <>
          {/* 上半屏：上传区域 */}
          <div className="upload-section mb-6">
            {isParent ? (
              <ExerciseUploadSection />
            ) : (
              <div className="grid grid-cols-2 gap-6">
                <ExerciseUploadSection />
                <MaterialUploadSection />
              </div>
            )}
          </div>

          {/* 中间区：AI处理进度 */}
          <AIProgressSection isParent={isParent} />

          {/* 下半屏：题目卡片 */}
          <ExerciseCardsSection />

          {/* 模态窗口 */}
          {showKnowledgePointsModal && <KnowledgePointsModal />}
          {showAssignModal && <AssignModal />}
        </>
      ) : (
        <ExerciseLibraryTab />
      )}
    </div>
  );
};
